var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailOpen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 32,
    width: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "email open") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "#444",
    strokeLinejoin: "miter",
    className: "nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "1 10 16 19 31 10",
    "data-cap": "butt",
    strokeLinecap: "butt",
    stroke: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,1L1,10V26c0,1.657,1.343,3,3,3H28c1.657,0,3-1.343,3-3V10L16,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOpen);
export default __webpack_public_path__ + "static/media/email-open.f4333ab587423d71f8f7f1b724474368.svg";
export { ForwardRef as ReactComponent };